let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4f4P5")).then(() => parcelRequire('754HR'));